module.exports = __webpack_public_path__ + "img/icon-safe.720bf77c.svg";